<template>
<div>
  <el-card body-style="padding: 0" >
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">我的商家</span>
    </div>
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="用户名" prop="businessName">
            <el-input v-model="queryForm.businessName" placeholder="请输入用户名"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="业务员名" prop="salemanName">
            <el-input v-model="queryForm.salemanName" placeholder="请输入业务用户名"/>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="2">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
               icon="el-icon-plus" @click="goToSharCode">邀请商家
    </el-button>
    <el-table :data="tableData"
              ref="table"
              border default-expand-all stripe
              :max-height="tableHeight"
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}">
      <el-table-column prop="businessId" label="用户ID">
        <template slot-scope="scope">
          <span style="text-align: center">{{ getStrEndWithNumbers(scope.row.businessId) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="businessName" label="用户名" />
      <el-table-column prop="salemanName" label="业务员/上级商家" width="140" />
      <el-table-column prop="createTime" label="创建时间" />
      <el-table-column prop="money" label="金额" />
      <el-table-column prop="shopNums" label="店铺数" />
      <el-table-column prop="orderTotalNums" label="放单总数" />
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text"
                     @click="handleBackEdit(scope.$index, scope.row,'添加备注')">
            添加备注
          </el-button>
          <el-button size="mini" type="text"
                     @click="handleAssignPrice(scope.$index, scope.row)">
            指定定价
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
  <el-dialog :title="dialogBackTitle" :visible.sync="dialogBackFormVisible">
    <el-form ref="dialogBackForm" :model="dialogBackForm" label-width="230px">
      <el-form-item label="备注">
        <el-input v-model="dialogBackForm.remarks" style="width: 50%;"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitBackDialogForm()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleBackCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {getStrEndWithNumbers} from "../../lib/utils";
import {addSalemanRemarks, queryBusiness} from "../../api/b2cbusiness/b2c_saleman";
import MinxinScroll from "@/components/MinxinScroll";

export default {
name: "MyBusiness",
  mixins: [MixinCUD, MinxinScroll],
  data() {
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
        businessName: '',
        salemanName: ''
      },
      dialogBackFormVisible: false,
      dialogBackTitle: "",
      dialogBackRefName: "dialogBackForm",
      dialogBackForm: {},
      tableHeight: 450,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
  this.getData();
  },
  methods:{
    handleAssignPrice(index, row){
      this.$router.push({path:'/home/addpricesetting', query:{userName:row.businessName, priceModeType:1, modelId:null}});
    },
    submitBackDialogForm(){
      this.$refs[this.dialogBackRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                this.dialogBackForm.salemanId = this.dialogBackForm.businessId;
                addSalemanRemarks(this.dialogBackForm).then(res=>{
                  if (res.success){
                    this.$message({message: res.data, type: 'success'});
                    this.getData();
                    this.dialogBackFormVisible = false;
                  }
                });
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleBackCloseDialog();});
        } else {
          return false;
        }
      });
    },
    handleBackEdit(index, row,dialogTitle) {
      this.dialogBackFormVisible = true;
      this.dialogBackTitle = dialogTitle
      this.resetBackDialogForm()
      this.dialogBackForm = {...row}
    },
    resetBackDialogForm(){
      for(let item in this.dialogBackForm){
        if (typeof this.dialogBackForm[item]==='string'){
          this.dialogBackForm[item]='';
        } else if (this.dialogBackForm[item] instanceof Array) {
          this.dialogBackForm[item]=[];
        } else{
          this.dialogBackForm[item]=null
        }
      }
    },
    handleBackCloseDialog(){
      this.$refs[this.dialogBackRefName].resetFields();
      this.dialogBackFormVisible = false;
    },
    goToSharCode(){
      this.$router.push({path:'/home/mysharecode'});
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    getData() {
      queryBusiness(this.queryForm, this.pagination).then(res => {
        console.log(res.data)
        if (res.success) {
          this.tableData = res.data.records;
          console.log(this.tableData)
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      })
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}
</style>
